// Secure IVS passwordless login (API v2).
export const EXTERNAL_LOGIN_CONFIG = {
    // v2 enforces HTTPS and a registered redirect_uri per client. The old
    // config pointed at http://, which redirects and strips nothing useful but
    // leaves the first hop in clear text.
    baseURL: "https://customer-api.secureivs.eu/",

    // Public credential - safe in the browser. The secret half (apikey) lives
    // server-side in config/services.php and never reaches this file.
    externalClientId: "gClRVckm2AeIufvSwrbssw09I0ClqeAh3yA",

    // Available login methods
    loginMethods: {
        SMS: "sms",
        EMAIL: "email",
    },
};

// Build the URL we send the browser to.
//
// redirectURI points at our BACKEND /api/ivs-callback, which under v2 exchanges
// the returned token for the verified profile before the browser sees anything.
//
// returnCode is the nonce our backend minted for this attempt. v2 echoes it
// back inside the validated token payload, which is what lets the callback
// prove the login belongs to the session that started it - under v1 we
// generated it and then never sent it, so it proved nothing.
export const generateExternalLoginURL = (loginMethod, redirectURI, returnCode = null) => {
    const { baseURL, externalClientId, loginMethods } = EXTERNAL_LOGIN_CONFIG;

    const params = new URLSearchParams({
        client_id: externalClientId,
        login_method: loginMethods[loginMethod],
        redirect_uri: redirectURI,
    });

    if (returnCode) {
        params.set("return_code", returnCode);
    }

    return `${baseURL}?${params.toString()}`;
};
